module.exports = __webpack_public_path__ + "static/media/inbox-msg.71387570.svg";